module.exports = require("colors");


//////////////////
// WEBPACK FOOTER
// external "colors"
// module id = 1
// module chunks = 0